import { connect } from 'react-redux';
import MessagingList from 'comp/left/chat_list';
import { getPMList } from 'selectors';

const mapToProps = state => ({
  list: getPMList(),
  selected: state.ui.selected_pm
});

export default connect(mapToProps)(MessagingList);



// WEBPACK FOOTER //
// ./src/containers/left/PMList.js